module.exports = __webpack_public_path__ + "static/media/confirm-email.664667a9.png";